import { render, staticRenderFns } from "./reserved-area-menu.vue?vue&type=template&id=291f6873&"
import script from "./reserved-area-menu.vue?vue&type=script&lang=js&"
export * from "./reserved-area-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports